import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to top on route pathname change,
 * except when the change is only a language switch between /fr and /en
 * for the same underlying page (compares the path segments after the lang prefix).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const prev = window.__prev_pathname__;
    window.__prev_pathname__ = pathname;

    const stripLang = (p) => {
      const parts = p.split("/").filter(Boolean);
      if (parts[0] === "fr" || parts[0] === "en") {
        return "/" + parts.slice(1).join("/");
      }
      return p;
    };

    if (prev && stripLang(prev) === stripLang(pathname)) {
      // Language switch on the same page — do not scroll.
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return null;
}
